import {Fragment, useEffect, useState, useContext} from 'react';

import LoginContext from '../../../../../store/login-context';
import Skip from '../Skip/Skip';
import classes from './AlternativeOptions.module.scss';
import bulb from '../../../../../assets/icons/bulb-fill-blue.svg';
import BackStep from '../General/BackStep/BackStep';
import ProgressBar from '../ProgressBar/ProgressBar';
import info from '../../../../../assets/icons/info-yellow.svg';
import Toast from '../../../../Form/Toast';

declare var _curLang: any;
declare function Translate(key: string): string;

const AlternativeOptions = (props) => {

    const ctx = useContext(LoginContext);

    const [lastGoChecked,setLastGoChecked] = useState(false);    
    const [hmoChecked,setHmoChecked] = useState(false);
    const [personalChangeDateChecked,setPersonalChangeDateChecked] = useState(false);
    const [oldCitizenChecked,setOldCitizenChecked] = useState(false);
    const [weaponChecked,setWeaponChecked] = useState(false);
    const [foreignPassportNumChecked,setForeignPassportNumChecked] = useState(false);
    const [immigrationDateChecked,setImmigrationDateChecked] = useState(false);
    const [nationalInsuranceChecked,setNationalInsuranceChecked] = useState(false);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [showErrorMsg,setShowErrorMsg] = useState(false);

    useEffect(() => {   
        //*** clean "alternative options" in context */                 
        // if(ctx.summaryRegOptions.length > 1){
        //     const regOptions = ctx.summaryRegOptions.slice();
        //     ctx.updateSummaryRegOptions([regOptions[0]]);
        // }

        //*** show relevant check boxes if exists in context */
        const userOptions = ctx.summaryRegOptions.slice(); 
        if (userOptions.length > 1){
            let selectedOptions: string[] = [];
            const alternativeOptionsIdsArr = userOptions[1].split(',');

            alternativeOptionsIdsArr.forEach((option) => {
                switch (option) {
                    case "lastGoDate":
                        setLastGoChecked(true);
                        selectedOptions.push("lastGoDate");
                        break;
                    case "hmoMobile":
                        setHmoChecked(true);
                        selectedOptions.push("hmoMobile");
                        break;                   
                    case "personalChangeDate":
                        setPersonalChangeDateChecked(true);
                        selectedOptions.push("personalChangeDate");
                        break;
                    case "oldCitizen":
                        setOldCitizenChecked(true);
                        selectedOptions.push("oldCitizen");
                        break;
                    case "foreignPassportNum":
                        setForeignPassportNumChecked(true);
                        selectedOptions.push("foreignPassportNum");
                        break;
                    case "immigrationDate":
                        setImmigrationDateChecked(true);
                        selectedOptions.push("immigrationDate");
                        break;
                    case "weapon":
                        setWeaponChecked(true);
                        selectedOptions.push("weapon");
                        break;
                    case "nationalInsurance":
                        setNationalInsuranceChecked(true);
                        selectedOptions.push("nationalInsurance");
                        break;
                    default:
                        break;
                }
            });

            setSelectedIds(selectedOptions);
        }
    },[]);
       
    
    const handleCheckBoxClick = (event) => {
        
        switch (event.target.id) {
            case "lastGoDate":
                setLastGoChecked(!lastGoChecked);
                break;           
            case "hmoMobile":
                setHmoChecked(!hmoChecked);
                break;
            case "personalChangeDate":
                setPersonalChangeDateChecked(!personalChangeDateChecked);
                break;
            case "oldCitizen":
                setOldCitizenChecked(!oldCitizenChecked);
                break;
            case "foreignPassportNum":
                setForeignPassportNumChecked(!foreignPassportNumChecked);
                break;
            case "immigrationDate":
                setImmigrationDateChecked(!immigrationDateChecked);
                break;
            case "weapon":
                setWeaponChecked(!weaponChecked);
                break;
            case "nationalInsurance":
                setNationalInsuranceChecked(!nationalInsuranceChecked);
                break;
            default:
                break;
        } 
        
        //Array of selected options
        if(selectedIds.indexOf(event.target.id) === -1){
            if(selectedIds.length >= 2 ){
                setShowErrorMsg(true);               
            }

            setSelectedIds([...selectedIds,event.target.id]); 
        }
        else{
            let index = selectedIds.findIndex(x => x === event.target.id);
            // const newArr = selectedIds.slice(indx);
            selectedIds.splice(index, 1);
            setSelectedIds([...selectedIds]);

            if(selectedIds.length <= 2){
                setShowErrorMsg(false);  
            }
        }
    };

    const handleCheckBoxPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){            
            handleCheckBoxClick(event);
        }       
    }

    const handleNoOption = () => {
        props.setCurrentScreenStep(ctx.preRegScreenCollection.bioIdFirst);
        props.AddUserStep(ctx.preRegScreenCollection.bioIdFirst);
    };

    const handleContinue = () => {
        if(ctx.summaryRegOptions.length === 1){
            ctx.updateSummaryRegOptions([...ctx.summaryRegOptions, selectedIds.join()]);
        }
        else if(ctx.summaryRegOptions.length > 1){
            const regOptions = ctx.summaryRegOptions.slice();
            regOptions[1] = selectedIds.join();
            ctx.updateSummaryRegOptions(regOptions);
        }

        if(selectedIds.length === 1){  
            // ctx.updateSummaryRegOptions([...ctx.summaryRegOptions, selectedIds.join()]);          
            props.setCurrentScreenStep(ctx.preRegScreenCollection.binuyShikun);
            props.AddUserStep(ctx.preRegScreenCollection.binuyShikun);
        }
        else if(selectedIds.length > 1){
            // ctx.updateSummaryRegOptions([...ctx.summaryRegOptions, selectedIds.join()]);
            props.setCurrentScreenStep(ctx.preRegScreenCollection.summaryOptions);
            props.AddUserStep(ctx.preRegScreenCollection.summaryOptions);
        }
    };

    const onBackStepHandler = () => {
        props.prevScreen(); 
    };

    return(
        <Fragment>
             <ProgressBar pbWidth="51%"/>
            <div className={classes.container}>
                <div className={classes.formWrapper}> 
                    <BackStep prevStep = {onBackStepHandler} />

                    <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_Login_SignUp_Details')}</div>
                    <div className={classes.desc_container}>
                        <div className={`preRegText ${classes.desc}`}>
                            <img src={bulb} alt="bulb" className={classes.bulb}/>
                            <span className={classes.desc_text}>{Translate('N_Login_SignUp_Two_Options')}</span>                        
                        </div>                    
                    </div>

                    {/* hmo */}
                    <div className={classes.check_container}>
                        <div>
                            <input 
                                    type="checkbox" 
                                    id="hmoMobile" 
                                    className={classes.check} 
                                    checked={hmoChecked}
                                    onChange={handleCheckBoxClick}
                                    onKeyPress={handleCheckBoxPress} 
                                >                        
                            </input>
                        </div>
                        <div>
                            <label htmlFor='hmoMobile'>
                                <div>
                                    <span className={classes.check_label}>{Translate('N_Login_SignUp_hmo')}</span>
                                    <span className={classes.check_label_remark_red}>({Translate('N_Login_SignUp_hmo_2')})</span>
                                </div>
                                <div>
                                    <span className={classes.check_label_remark}>{Translate('N_Login_SignUp_hmo_3')}</span>
                                </div>
                            </label>
                            {hmoChecked &&                                                                                       
                                <div className={classes.background_remark}>
                                    <div className={classes.background_remark_icon}>
                                        !
                                    </div>
                                    <div>
                                        {Translate('N_Login_SignUp_hmo_rem')}
                                    </div>                                        
                                </div>
                            }
                        </div>
                    </div>
                    

                    {/* Last Go Date */}
                    <div className={classes.check_container}>
                        <input 
                                type="checkbox" 
                                id="lastGoDate" 
                                className={classes.check} 
                                checked={lastGoChecked}
                                onChange={handleCheckBoxClick}
                                onKeyPress={handleCheckBoxPress} 
                            >                        
                        </input>
                        <label htmlFor='lastGoDate'>
                            <span className={classes.check_label}>{Translate('N_Login_SignUp_Last_Exit_Date')}</span>                            
                        </label>
                    </div>                                         

                    {ctx.summaryRegOptions.indexOf("imiggrationCert") > -1 &&                    
                         <>
                            {/* Foreign passport */}
                            <div className={classes.check_container}>
                                <input 
                                        type="checkbox" 
                                        id="foreignPassportNum" 
                                        className={classes.check} 
                                        checked={foreignPassportNumChecked}
                                        onChange={handleCheckBoxClick}
                                        onKeyPress={handleCheckBoxPress} 
                                    >                        
                                </input>
                                <label htmlFor='foreignPassportNum'>
                                    <span className={classes.check_label}>{Translate('N_Login_SignUp_Foreign_Passport_Num')}</span><br/>                                      
                                </label>
                            </div>
                        
                            {/* Immigration Date */}
                            <div className={classes.check_container}>
                                <input 
                                        type="checkbox" 
                                        id="immigrationDate" 
                                        className={classes.check} 
                                        checked={immigrationDateChecked}
                                        onChange={handleCheckBoxClick}
                                        onKeyPress={handleCheckBoxPress} 
                                    >                        
                                </input>
                                <label htmlFor='immigrationDate'>
                                    <span className={classes.check_label}>{Translate('N_Login_SignUp_Immigration_Date')}</span><br/>                                    
                                </label>
                            </div>
                        </>                                                               
                    }

                    {ctx.summaryRegOptions.indexOf("imiggrationCert") === -1 &&
                        <>
                            {/* Personal Change Date */}
                            <div className={classes.check_container}>
                                <input 
                                        type="checkbox" 
                                        id="personalChangeDate" 
                                        className={classes.check} 
                                        checked={personalChangeDateChecked}
                                        onChange={handleCheckBoxClick}
                                        onKeyPress={handleCheckBoxPress} 
                                    >                        
                                </input>
                                <div>
                                    <div>
                                        <label htmlFor='personalChangeDate'>
                                            <span className={classes.check_label}>{Translate('N_Login_SignUp_Personal_Change_Date')}</span><br/> 
                                            <span className={classes.check_label_remark}>{Translate('N_General_SignUp_question_14')}</span>                   
                                        </label>
                                    </div>
                                    {personalChangeDateChecked && 
                                        <div className={classes.background_remark}>
                                            <div className={classes.background_remark_icon}>
                                                !
                                            </div>
                                            <div>
                                                {Translate('N_Login_SignUp_Personal_Change_Date_Rem')}
                                            </div>                                        
                                        </div>
                                    }
                                </div>
                            </div>

                             {/* National Insurance */}
                             <div className={classes.check_container}>
                                <input 
                                        type="checkbox" 
                                        id="nationalInsurance" 
                                        className={classes.check} 
                                        checked={nationalInsuranceChecked}
                                        onChange={handleCheckBoxClick}
                                        onKeyPress={handleCheckBoxPress} 
                                    >                        
                                </input>
                                <label htmlFor='nationalInsurance'>
                                    <span className={classes.check_label}>{Translate("N_Login_SignUp_National_Insurance_Details")}</span><br/>
                                    <span className={classes.check_label_remark}>{Translate("N_Login_SignUp_National_Insurance_Citizen")}</span>                
                                </label>
                            </div>

                            {/* Old Citizen*/}
                            <div className={classes.check_container}>
                                <input 
                                        type="checkbox" 
                                        id="oldCitizen" 
                                        className={classes.check} 
                                        checked={oldCitizenChecked}
                                        onChange={handleCheckBoxClick}
                                        onKeyPress={handleCheckBoxPress} 
                                    >                        
                                </input>
                                <div>
                                    <div>
                                        <label htmlFor='oldCitizen'>
                                            <span className={classes.check_label}>{Translate('N_General_SignUp_senior_tooltip')}</span><br/>
                                            <span className={classes.check_label_remark}>{Translate('N_General_SignUp_question_12')}</span>                    
                                        </label>
                                    </div>
                                    {oldCitizenChecked && 
                                        <div className={classes.background_remark}>
                                            <div className={classes.background_remark_icon}>
                                                !
                                            </div>
                                            <div>
                                                {Translate('N_General_SignUp_senior_Rem')}
                                            </div>                                        
                                        </div>
                                    }
                                </div>
                            </div>

                             {/* Weapon */}
                            <div className={classes.check_container}>
                                <input 
                                        type="checkbox" 
                                        id="weapon" 
                                        className={classes.check} 
                                        checked={weaponChecked}
                                        onChange={handleCheckBoxClick}
                                        onKeyPress={handleCheckBoxPress} 
                                    >                        
                                </input>
                                <label htmlFor='weapon'>
                                    <span className={classes.check_label}>{Translate("N_General_SignUp_FireArm__License_Number")}</span><br/>
                                    <span className={classes.check_label_remark}>{Translate("N_General_SignUp_FireArm_License_Valid")}</span>                
                                </label>
                            </div>
                            
                        </>
                    }
                                                                         
                    <div className={classes.buttons_container}>
                        {showErrorMsg && <Toast message={Translate('N_Login_SignUp_Options_Error')}/>}
                        <div className={classes.buttons_wrapper}>
                            <button 
                                className={`${classes.btn_no_idn} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_idn_ltr : ''}`} 
                                id='btnAltNoIdentityOptions' 
                                onClick={handleNoOption}>
                                <span>{Translate('N_General_Questions_No_Answer')}</span>                     
                            </button>
                            <button 
                                className={classes.btn_continue} 
                                id='btnAltContinue' 
                                onClick={handleContinue}
                                disabled={  (!lastGoChecked &&                                         
                                            !hmoChecked &&
                                            !personalChangeDateChecked && 
                                            !oldCitizenChecked &&
                                            !foreignPassportNumChecked &&
                                            !immigrationDateChecked &&
                                            !weaponChecked &&
                                            !nationalInsuranceChecked) || selectedIds.length > 2
                                        }
                                >
                                <span>{Translate('N_General_next')}</span>                     
                            </button>
                        </div>
                    </div>
                    <div className={classes.buttons_container_mobile}>   
                        {showErrorMsg && <Toast message={Translate('N_Login_SignUp_Options_Error')}/>}                         
                        <button 
                            className={classes.btn_continue} 
                            id='btnAltContinueMobile' 
                            onClick={handleContinue}
                            disabled={  (!lastGoChecked &&                                        
                                        !hmoChecked &&
                                        !personalChangeDateChecked && 
                                        !oldCitizenChecked &&
                                        !foreignPassportNumChecked &&
                                        !immigrationDateChecked &&
                                        !weaponChecked &&
                                        !nationalInsuranceChecked) || selectedIds.length > 2
                                    }
                            >
                            <span>{Translate('N_General_next')}</span>                     
                        </button>
                        <button 
                            className={`${classes.btn_no_idn} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_idn_ltr : ''}`} 
                            id='btnAltNoIdentityOptionsMobile' 
                            onClick={handleNoOption}>
                            <span>{Translate('N_General_Questions_No_Answer')}</span>                     
                        </button>
                    </div>
                </div>
                <div className={classes.skip}>
                    <Skip />
                </div>
            </div>                 
        </Fragment>       
    );
};
export default AlternativeOptions;